import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionService } from './shared/services/session.service';
import { GetGuidService } from './shared/services/api/get-guid.service';
import { environment } from 'src/environments/environment';
import { UserService } from './shared/services/user.service';
import { AuthService } from '@auth0/auth0-angular'; // Import Auth0 service



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  userClaims: import("@auth0/auth0-angular").User;
  sessionId: string = '';
  constructor(private router: Router, private sessionService: SessionService, public getTokenService: GetGuidService, private userService: UserService, private auth: AuthService) {
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let sessionId = route.paramMap.get('id');
    const walletID = sessionStorage.getItem('WalletID');
    
    if (sessionId != null && sessionId != undefined && sessionId != '') {

      console.log('AuthGuard - Session ID:', sessionId);
      console.log('AuthGuard - route.routeConfig:', route.routeConfig); // Log the route config
      let isPPI = false;
      if (route.routeConfig && (route.routeConfig.path === 'home/PPI/:id' || route.routeConfig.path === 'home/PPI') ){
        isPPI = true;
        console.log('AuthGuard - Detected PPI Route');

      } else {
        console.log('AuthGuard - Detected ONL or other Route');

      }

      const redirectUrl = isPPI ? environment.ppiLoginUrl : environment.loginUrl;
      console.log('AuthGuard - Determined Redirect URL:', redirectUrl);

      if (sessionId) { // This block handles scenarios where a session ID is provided in the URL
        sessionStorage.setItem("SessionID", sessionId); // Store the raw session ID from the URL
        // Validate session ID using SessionService
        return this.sessionService.fetchSessionObject(sessionId, isPPI).pipe(
          map((session) => {
            // --- CRITICAL DEBUGGER HERE ---
            // Execution MUST stop here if session.service.ts's debugger was hit.
            console.log('AuthGuard MAP - Full session object received from service:', session);
            console.log('AuthGuard MAP - Value of session.walletID:', session?.walletID);
            console.log('AuthGuard MAP - Value of session.message:', session?.message); // Add this for clarity

            // The primary condition for allowing access
            if (session && session.walletID) { // `session.walletID` must be a truthy value (non-empty string)
              console.log('AuthGuard MAP - Session VALID and walletID PRESENT. Allowing route activation.');
              return true; // Allows the route to activate
            } else {
              // If session object is null/undefined, or walletID is missing/empty
              console.log('AuthGuard MAP - Session INVALID or walletID MISSING/EMPTY. Redirecting to login.');
              sessionStorage.clear(); // Clear all session data
              // window.location.href = environment.loginUrl; // Redirect to the login page
              window.location.href = redirectUrl;
              return false; // Prevents route activation
            }
          }),
          catchError((error) => {
            // --- DEBUGGER HERE IF API CALL FAILS ---
            // This block should NOT be hit if PPIRes was logged in SessionService's tap.

            console.error('AuthGuard CATCHERROR - Error during session fetch:', error);
            sessionStorage.clear();
            //    window.location.href = environment.loginUrl;
            window.location.href = redirectUrl;
            return of(false); // Prevents route activation
          })
        );
      } else if (walletID) { // This block handles scenarios where no session ID in URL, but WalletID exists in storage
        console.log('AuthGuard - No session ID in URL, but WalletID found in sessionStorage. Allowing access.');
        return true; // Allows the route to activate
      } else { // No session ID in URL and no WalletID in storage
        console.log('AuthGuard - No session ID in URL and no existing WalletID. Redirecting to login.');
        window.location.href = redirectUrl;
        // window.location.href = environment.loginUrl; // Redirect to the login page
        return false; // Prevents route activation
      }
    }
    else {
      console.log("auth gaurd line-94 this.auth.isAuthenticated$.subscribe");
      if(sessionStorage.getItem('SessionID')!='' && sessionStorage.getItem('SessionID')!=undefined
     && sessionStorage.getItem('SessionID')!=null)
      { sessionId=sessionStorage.getItem("SessionID");
        return true;
      }
else{      this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }
        else{
      this.auth.loginWithRedirect();
      return true;
        }});
        return true;
    }
  }
  }

  private checkTokenExpiration(exp: number): boolean {
    const currentTime = Math.floor(Date.now() / 1000);
    return Number(exp) < currentTime;
  }


  checkAccess(route, state) {
    // Sample example of one page within IB application
    if (state.url.startsWith('/my-wallet/all-rewards/redeem/outstanding-invoice')) {
      if (!this.userService.isRewardEligible()) { // Not reward eligible users (is4u) cannot view this URL
        this.router.navigate(['/unauthorized']);
        return false;
      } else {
        return true;
      }
    } else if (state.url.startsWith('/enter-all-other-urls-here')) {
      let scenariosWhereUserIsNotAllowedToViewThisPage; // Replace with whatever the condition is (not reward eligible, autopay is on, etc)
      if (scenariosWhereUserIsNotAllowedToViewThisPage) {
        this.router.navigate(['/unauthorized']);
        return false;
      } else {
        return true;
      }
    } else if (state.url.startsWith('/enter-all-other-urls-here-2')) {
      return true;
    } else {
      return true; // For any pages that do not need routeGuard auth, we can simply return true at the very bottom else block
    }
  }
}
